import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import ProviderHelper from "../../../helper/providerHelper";
import RatioOverflowTableWrapper from "../../../components/styled-components/ratio-overflow-table-wrapper/RatioOverflowTableWrapper";
import {providerTranslateHelper} from "../../../helper/TraslateHelper";

const ProductsOverviewGrid = (props) => {

  const generateRow = (row) => {
    return (
      <TableRow key={row.id}>
        <TableRowColumn>{row.name}</TableRowColumn>
        <TableRowColumn>{row.type}</TableRowColumn>
        <TableRowColumn>{providerTranslateHelper(ProviderHelper.getQuotationProviderName(row.provider))}</TableRowColumn>
        <TableRowColumn>{row.sellingPricePerMonth}</TableRowColumn>
        <TableRowColumn>{row.createdBy}</TableRowColumn>
        <TableRowColumn>{new Date(row.createdAt).toLocaleString('nl-NL')}</TableRowColumn>
        <TableRowColumn>{new Date(row.updatedAt).toLocaleString('nl-NL')}</TableRowColumn>
        <TableRowColumn>{row.active ? 'Actief' : 'Inactief'}</TableRowColumn>
        <TableRowColumn>
            <div>
                <a href="#" onClick={() => props.onEditClick(row)}>
                    <i className="small material-icons left themeprimarycolor">edit</i>
                </a>
                <a href="#" onClick={() => props.onViewClick(row)}>
                    <i className="small material-icons left themeprimarycolor">remove_red_eye</i>
                </a>
                <a href="#" onClick={() => props.onCloseClick(row)}>
                    <i className="small material-icons left themeprimarycolor">close</i>
                </a>
            </div>
        </TableRowColumn>
      </TableRow>
    );
  }

  const getIcon = (sortDirection) => {
      switch (sortDirection) {
          case "ASC":
              return 'arrow_downward';
          case "DESC":
              return 'arrow_upward';
          case false:
              return 'swap_vert'
    }
  }

  const generateHeader = () => {
    return (
      props.headerNames.map(headerName =>
        <TableHeaderColumn key={headerName} className="clickable" headername={headerName} >
            {headerName}<i className="material-icons right lightgrey">{getIcon(props.sortingState[props.getPropertyNameFromDisplayName(headerName)])}</i>
        </TableHeaderColumn>
      )
    );
  }

  return (
      <RatioOverflowTableWrapper>
          <div className="valign-wrapper">
              <Table selectable={false}>
                  <TableHeader displaySelectAll={false} adjustForCheckbox={false} >
                      <TableRow onCellClick = {props.onHeaderClick}>
                          {
                              generateHeader()
                          }
                      </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                      {
                          props.rows.map(row =>
                              generateRow(row)
                          )
                      }
                  </TableBody>
              </Table>
          </div>
      </RatioOverflowTableWrapper>
  );
};

ProductsOverviewGrid.propTypes = {
  onHeaderClick: PropTypes.func.isRequired,
  getPropertyNameFromDisplayName: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onViewClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  rows: PropTypes.array.isRequired,
  sortingState: PropTypes.array.isRequired,
  headerNames: PropTypes.array.isRequired
}

export default ProductsOverviewGrid;